import { Component, OnInit } from '@angular/core';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { QueryParamsService } from 'src/app/services/query-params.service';

@Component({
  selector: 'app-history-operations',
  templateUrl: './history-operations.component.html',
  styleUrls: ['./history-operations.component.scss']
})
export class HistoryOperationsComponent implements OnInit {
  history = 6;
  permissionType = PermissionTypeEnum;
  warehouseList: WarehouseResponse[] = [];
  warehouseNames: { [key: number]: WarehouseResponse } = [];

  constructor(
    private authService: AuthenticationService,
    private warehouseService: WarehouseService,
    private queryParamsService: QueryParamsService
  ) {
    var permissions = authService.getPermissions();
    if (permissions) {
      for (let i = 0; i < permissions.length; i++) {
        const element = permissions[i];
        if (element.roleId == 5017) {
          this.history = 0;
          break;
        } else if (element.roleId == 5023) {
          this.history = 1;
          break;
        } else if (element.roleId == 5018) {
          this.history = 2;
          break;
        }
      }
    }
  }

  ngOnInit(): void {
    this.history = this.queryParamsService.getNumberParam("history", 6);
    this.getWarehouses();
  }

  getWarehouses() {
    this.warehouseService.getWarehouseByClue("").subscribe({
      next: (response: ResponseObject) => {
        this.warehouseList = response.data;
        this.warehouseList.forEach((w) => {
          this.warehouseNames[w.id] = w;
        })
      }
    })
  }

  updateIndexParam(value: any) {
    if (value == this.history) {
      return;
    }
    this.queryParamsService.setParams({
      history: value,
      type: null,
      startDate: null,
      endDate: null
    });
  }
}
